import React from 'react';
import classes from './HLModal.module.scss';
import CloseIcon from '../../styles/icons/CloseIcon';
import HLIconButton from '../icon-button/HLIconButton';
import cn from 'classnames';

export enum HLModalSizeType {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE'
}

interface HLModalProps {
    open: boolean;
    onClose: () => void;
    title?: string;
    children: React.ReactNode;
    sizeType?: HLModalSizeType;
}

const HLModal: React.FC<HLModalProps> = ({
                                             open,
                                             onClose,
                                             title,
                                             children,
                                             sizeType = HLModalSizeType.SMALL,
                                         }) => {
    if (!open) return null;

    const modalClassNames = cn(classes.modal, {
        [classes.small]: sizeType === HLModalSizeType.SMALL,
        [classes.medium]: sizeType === HLModalSizeType.MEDIUM,
        [classes.large]: sizeType === HLModalSizeType.LARGE
    });

    return (
        <div className={classes.overlay}>
            <div
                className={modalClassNames}
            >
                {title && <h2 className={classes.title}>{title}</h2>}

                <div className={classes.close}>
                    <HLIconButton
                        icon={<CloseIcon/>}
                        onClick={onClose}
                        aria-label="Закрыть"
                    />
                </div>

                {children}
            </div>
        </div>
    );
};

export default HLModal; 